var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCat2022 = function SvgCat2022(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDE7E0",
    fillRule: "evenodd",
    d: "M28.79 71.765c-6.546-1.364-9.364-8.92-13.419-14.231-3.91-5.122-7.84-9.985-9.758-16.133-2.464-7.896-7.246-17.085-2.775-24.04 4.468-6.952 15.061-5.251 23.03-7.476 7.015-1.958 13.757-6.704 20.777-4.753 7.001 1.945 10.967 8.934 15.285 14.772 4.114 5.562 9.356 11.206 9.04 18.11-.31 6.74-6.037 11.698-10.634 16.639-3.85 4.138-8.639 6.717-13.61 9.414-5.861 3.179-11.402 9.06-17.935 7.698",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#402C28",
    d: "M39.32 19.55c3.114.44 12.943 1.404 17.232 7.023 4.29 5.62 10.044 10.803 8.05 15.682-2.43 5.956-6.355 22.06-22.477 25.454s-28.198-10.24-30.768-16.698a19.02 19.02 0 0 1-.094-14.146c2.936-7.796 7.74-14.028 10.465-15.794 4.819-3.189 14.479-1.957 17.593-1.522"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A4144",
    d: "M39.639 14.478c3.114.44 16.492 3.011 20.78 8.644 4.29 5.633 8.537 13.72 6.556 18.6-2.435 5.95-9.023 20.752-25.126 24.147S8.65 58.152 6.079 51.695c-1.264-3.16-.96-10.489 1.316-16.576 2.917-7.792 11.299-14.132 14.01-15.92 4.837-3.152 15.12-5.152 18.234-4.72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__a)",
    d: "M39.639 14.478c3.114.44 15.092 2.342 19.376 7.96 1.61 2.112 4.612 5.259 5.881 7.76 2.117 4.176 3.31 8.475 2.065 11.528-2.434 5.951-9.023 20.753-25.126 24.147C25.732 69.268 8.65 58.152 6.079 51.695c-.777-1.943-.936-5.455-.468-9.286.323-2.402 1.672-5.66 2.538-8.007 2.917-7.791 10.531-13.401 13.242-15.18 4.851-3.175 15.134-5.175 18.248-4.744"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__b)",
    d: "M40.852 12.643c3.114.44 15.279 4.86 19.568 10.493s6.944 10.185 2.945 17.138c-2.533 4.406-12.137 12.498-24.012 15.172-16.056 3.614-31.246-2.702-32.993-7.96-1.072-3.227-1.24-6.28 1.035-12.367 2.917-7.778 10.676-15.72 13.397-17.503 4.823-3.175 16.946-5.441 20.06-4.973"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__c)",
    d: "M59.188 21.736S55.148 9.726 47.075 0a116 116 0 0 1-6.724 12.587s4.251 6.05 18.837 9.15"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__d)",
    d: "M9.371 8.845s6.884 5.362 11.42 8.77c0 0-2.495 9.483-13.11 16.886-.033 0-3.634-12.067 1.69-25.656"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#494D4C",
    d: "M55.606 27.894s-7.628-2.267-11.589-.703-4.242 12.175-4.242 12.175c.851-.395 1.745-.69 2.664-.88 2.009-.51 6.925.58 9.463-2.857a26.6 26.6 0 0 0 3.704-7.735M31.94 40.874s-2.687-5.287-4.654-6.879c-1.966-1.592-3.97-2.81-7.665-.417a31.6 31.6 0 0 0-6.237 5.385S15 40.368 18.1 42.57c3.1 2.2 5.118 1.994 7.806.702 1.442-.698 3.962-2.88 6.036-2.397"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__e)",
    d: "M54.038 29.921s-1.03 4.945-4.346 6.883c-3.315 1.939-8.794.937-8.794.937s-.828-7.075 4.121-9.206 9.019 1.386 9.019 1.386"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__f)",
    d: "M36.272 42.194c2.843-.36 3.582.06 4.435 1.011 1.044 1.162-.764 4.837-2.96 5.516-2.669.83-6.42-2.603-5.38-4.284.759-1.222 2.669-2.084 3.905-2.243"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__g)",
    d: "M30.681 40.04s-2.81-6.214-7.244-6.424c-4.574-.22-8.597 5.455-8.597 5.455a10.72 10.72 0 0 0 8.2 4.102c2.865.098 7.641-3.133 7.641-3.133"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__h)",
    d: "M47.843 27.856s2.34 2.477 1.09 7.59c0 0-2.34-3.647-2.528-7.374q.713-.15 1.438-.216"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__i)",
    d: "M24.426 33.76s1.31 1.958.758 6.898c0 0-2.89-3.16-2.744-7.023z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1E20",
    d: "M54.038 29.921a14 14 0 0 0-2.121-1.03 12 12 0 0 0-2.234-.641 6.9 6.9 0 0 0-4.43.552 6.33 6.33 0 0 0-3.217 3.039 16.6 16.6 0 0 0-1.194 4.519 12.1 12.1 0 0 1 .698-4.744 6.2 6.2 0 0 1 1.367-2.06 7.5 7.5 0 0 1 2.051-1.405 7 7 0 0 1 2.384-.665c.822-.06 1.65.013 2.449.216a10.6 10.6 0 0 1 4.247 2.22M29.867 38.542a15 15 0 0 0-1.49-1.827 11.7 11.7 0 0 0-1.741-1.53A5.8 5.8 0 0 0 22.42 34a9 9 0 0 0-4.069 1.934c-1.236.936-2.341 2.074-3.516 3.137.468-.623.974-1.241 1.489-1.873a18 18 0 0 1 1.68-1.705 8.6 8.6 0 0 1 4.323-2.2 5.45 5.45 0 0 1 2.486.234c.782.27 1.509.68 2.145 1.208a10.7 10.7 0 0 1 2.907 3.807"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__j)",
    d: "M35.991 40.27c3.676-.553 4.603-.17 5.62.74 1.264 1.11-1.298 4.958-4.163 5.787-3.484 1.011-8.092-2.229-6.645-3.999 1.072-1.302 3.568-2.304 5.188-2.529"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#343B3D",
    d: "m36.84 43.842-.68.154.711 3.147.68-.154z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#343B3D",
    d: "M41.273 43.64c-.3.891-.84 1.682-1.56 2.286a6 6 0 0 1-2.528 1.278 5.7 5.7 0 0 1-2.81-.07 5.3 5.3 0 0 1-2.387-1.405 7.2 7.2 0 0 0 5.066.778 6.8 6.8 0 0 0 2.341-1.026 7.7 7.7 0 0 0 1.878-1.84"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__k)",
    d: "M42.388 26.653c-5.573 1.774-4.215 13.35-4.215 13.35s-.81-.206-4.682 1.058c0 0-3.123-10.826-8.162-11.018.01 0 7.914-6.841 17.059-3.39"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0AE94",
    d: "M42.434 40.47a26 26 0 0 0-3.23-.177c-1.061.002-2.12.104-3.161.304a13.4 13.4 0 0 0-3.006.984c-.978.45-1.906 1-2.772 1.638a8.8 8.8 0 0 1 2.519-2.12 10.3 10.3 0 0 1 3.118-1.185 12 12 0 0 1 3.325-.164c1.099.081 2.18.324 3.207.72"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__l)",
    d: "M42.388 26.653s-2.028-9.482-6.04-13.78c0 0-6.631.495-10.808 2.439 0 0-.745 9.323-.201 14.73 0 0 6.69-5.042 17.049-3.39"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__m)",
    d: "M44.944 29.706c2.52-.895 5.024 3.03.604 5.15-3.554 1.667-4.42-3.792-.604-5.15",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__n)",
    d: "M21.354 34.82c2.519-.895 5.347 3.918.604 5.15-2.931.768-4.42-3.793-.604-5.15",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__o)",
    d: "M38.16 42.33s-.853 1.76-1.612 2.379c0 0-1.905-.937-2.22-1.513-.313-.576 3.789-1.658 3.831-.866"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__p)",
    d: "M47.075 0s.702 10.578 1.845 13.415c1.142 2.838 7.726 5.479 7.726 5.479a20.7 20.7 0 0 0-2.571-9.06c-2.543-4.552-7-9.834-7-9.834"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-400953848__q)",
    d: "M9.371 8.845s5.01 10.527 4.032 13.631c-.979 3.105-5.338 7.398-5.338 7.398a20.8 20.8 0 0 1-1.48-10.605A37.1 37.1 0 0 1 9.371 8.845"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D9286",
    d: "M55.958 40.593a33 33 0 0 0-3.105-.202c-1.04-.023-2.08 0-3.119.052-2.08.106-4.148.377-6.185.81a39 39 0 0 1 6.176-.937 44 44 0 0 1 3.133-.121 30 30 0 0 1 3.132.135zM53.284 46.118a16.5 16.5 0 0 0-2.21-1.47q-1.163-.661-2.412-1.138c-1.664-.66-3.44-.99-5.23-.974 1.8-.076 3.596.2 5.291.81q1.276.448 2.472 1.077c.807.412 1.578.891 2.304 1.433zM18.132 48.876c.9-.543 1.83-1.02 2.772-1.47s1.906-.862 2.875-1.236a39.5 39.5 0 0 1 5.99-1.803 39.4 39.4 0 0 0-5.938 1.929 43 43 0 0 0-2.838 1.292c-.936.469-1.845.965-2.716 1.517zM22.8 52.805a30.7 30.7 0 0 1 3.484-4.018 25.8 25.8 0 0 1 4.14-3.31 25.6 25.6 0 0 0-4.05 3.399 30.4 30.4 0 0 0-3.363 4.069z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#F39786",
    d: "M12.977 22.823a12 12 0 0 0-.305-1.84 11 11 0 0 0-.599-1.785 6.1 6.1 0 0 0-2.374-2.875 6.23 6.23 0 0 1 2.664 2.735q.462.864.773 1.793a12.6 12.6 0 0 1 .468 1.906zM12.686 23.932a20 20 0 0 0-1.563-1.456q-.41-.345-.853-.646a4.6 4.6 0 0 0-.936-.501c.354.08.697.202 1.02.365q.498.234.965.524.937.572 1.803 1.246zM48.194 12.207q.325-1.095.791-2.14.23-.523.52-1.016c.188-.328.42-.629.688-.894a4.1 4.1 0 0 0-.548.97q-.209.514-.36 1.048a17 17 0 0 0-.468 2.163zM48.98 13.837q.705-.893 1.541-1.662.416-.383.885-.698a2.5 2.5 0 0 1 1.035-.422 2.3 2.3 0 0 0-.937.553q-.405.37-.744.8-.692.847-1.246 1.79z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E5251",
    d: "M54.703 18.009a15.7 15.7 0 0 1-3.503-1.714 10 10 0 0 1-1.55-1.236 4.7 4.7 0 0 1-1.128-1.71 17.3 17.3 0 0 1-.801-3.848 28 28 0 0 1-.164-3.887l.655 3.817c.206 1.248.508 2.479.904 3.68a4.15 4.15 0 0 0 .965 1.517q.653.68 1.405 1.25a32 32 0 0 0 3.217 2.13M11.652 14.048a21 21 0 0 1 1.648 3.867 9.6 9.6 0 0 1 .5 4.261c-.4 1.39-1.084 2.681-2.008 3.793a21 21 0 0 1-2.908 3.063c.88-1.091 1.733-2.197 2.505-3.34q.577-.853 1.059-1.764c.323-.59.57-1.22.73-1.873a6.4 6.4 0 0 0 0-1.986 18 18 0 0 0-.346-2.023 51 51 0 0 0-1.18-3.998"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-400953848__a",
    x1: 35.674,
    x2: 24.346,
    y1: 65.085,
    y2: 14.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3A4144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-400953848__c",
    x1: 45.44,
    x2: 40.189,
    y1: 22.51,
    y2: -0.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#615F58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69655D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-400953848__d",
    x1: 39769.2,
    x2: 39769.2,
    y1: -7673.67,
    y2: -9024.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#615F58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69655D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-400953848__h",
    x1: 43.25,
    x2: 41.545,
    y1: 34.444,
    y2: 26.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1C11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4D3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-400953848__i",
    x1: 7982.15,
    x2: 7982.15,
    y1: -1921.64,
    y2: -2033.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1C11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4D3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-400953848__k",
    x1: 30.726,
    x2: 27.511,
    y1: 39.396,
    y2: 25.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6C2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-400953848__m",
    x1: 39.955,
    x2: 38.798,
    y1: 33.912,
    y2: 28.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F433F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-400953848__n",
    x1: 15094.3,
    x2: 15094.3,
    y1: -1469.71,
    y2: -1528.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F433F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-400953848__o",
    x1: 30.821,
    x2: 30.27,
    y1: 43.727,
    y2: 41.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#482424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#733939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-400953848__p",
    x1: 40.981,
    x2: 49.12,
    y1: 12.01,
    y2: 6.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#CA605A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D86A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ED7862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57D64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-400953848__q",
    x1: 19695,
    x2: 19829.9,
    y1: -6818.68,
    y2: -6847.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#CA605A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D86A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ED7862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57D64"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-400953848__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-33.65454 7.55537 -5.4014 -24.05995 36.938 33.634)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#877E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#726D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575753"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-400953848__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(167.347 18.956 18.2)scale(9.49548)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E8AB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D69C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B98438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37F36"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-400953848__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.74104 1.07461 -.87456 -3.8584 42.208 47.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F806D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615E59"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-400953848__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(349.767 0 0 211.205 43783.3 -2683.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E8AB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D69C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B98438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37F36"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-400953848__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-150.97622 33.89385 -12.90903 -57.50179 3442.38 19405.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F806D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615E59"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-400953848__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-20.79209 4.66778 -4.04775 -18.03023 32.275 27.636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#92897A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#716B63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65605B"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCat2022);
export default ForwardRef;